const scrollbarContextKey = /* @__PURE__ */ Symbol(
  "scrollbarContextKey"
);

export { scrollbarContextKey };
//# sourceMappingURL=constants.mjs.map
